/**
 * 新增流水
 */
<template>
  <div class="start-statistics-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增流水</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 新增流水统计折线图 -->
    <el-card shadow="hover" class="total-flow-card chart-card">
      <div slot="header" class="chart-card-header total-flow-header">
        <div class="chart-title-left">
          <i class="el-icon-s-data header-icon"></i>
          <span>新增流水统计</span>
        </div>
        <el-form :inline="true" size="small" class="total-flow-form">
          <el-form-item label="月份范围">
            <el-date-picker
              v-model="chartStartMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="开始月份"
              style="width: 120px"
            />
            <span class="range-sep">至</span>
            <el-date-picker
              v-model="chartEndMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="结束月份"
              style="width: 120px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" @click="fetchStartChart">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-loading="chartLoading" class="chart-body">
        <div ref="startChartRef" class="chart-single-wrap"></div>
        <div v-if="!chartLoading && chartData.length === 0" class="chart-empty">
          <i class="el-icon-document"></i>
          <p>暂无数据</p>
        </div>
      </div>
    </el-card>

    <!-- 明细列表搜索区 -->
    <div class="search-section">
      <el-form :inline="true" size="small" class="search-form">
        <el-form-item label="查询月份">
          <el-date-picker
            v-model="formInline.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择月份"
            style="width: 140px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item>
          <span class="current-month-tip">当前查询月份：{{ formInline.month || "未选择" }}</span>
        </el-form-item>
      </el-form>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
      >
        <el-table-column fixed prop="merchantName" label="商户名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="providerName" label="服务商名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="signDate" label="签约时间" width="140">
        </el-table-column>
        <el-table-column prop="startDate" label="启动时间" width="140">
        </el-table-column>
        <el-table-column prop="newFlowAmount" label="新增流水" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ formatAmount(scope.row.newFlowAmount) }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  getSalesTeamStartStatisticsMonthly,
  getSalesTeamStartStatisticsList,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      loading: false, // 显示加载
      // 明细列表查询条件与分页
      formInline: {
        page: 1,
        pageSize: 10,
        month: (() => {
          const n = new Date();
          return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}`;
        })(),
      },
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      // 新增流水统计折线图（默认当年1月至当前月）
      chartStartMonth: (() => {
        const n = new Date();
        return `${n.getFullYear()}-01`;
      })(),
      chartEndMonth: (() => {
        const n = new Date();
        return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}`;
      })(),
      chartData: [],
      startChart: null,
      chartLoading: false,
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.startChartRef) {
        this.startChart = echarts.init(this.$refs.startChartRef);
        this.fetchStartChart();
      }
    });
    window.addEventListener("resize", this.handleChartResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleChartResize);
    if (this.startChart) {
      this.startChart.dispose();
      this.startChart = null;
    }
  },
  methods: {
    formatAmount(num) {
      const v = Number(num);
      return isNaN(v) ? "0.00" : v.toFixed(2);
    },
    // 明细列表查询
    getdata(formInline) {
      const params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        month: formInline.month,
      };
      this.loading = true;
      getSalesTeamStartStatisticsList(params)
        .then((res) => {
          if (res.msg == "success") {
            this.listData = res.data.items || [];
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata(this.formInline);
    },
    // 生成从 startMonth 到 endMonth 的月份列表（yyyy-MM）
    getMonthRange(startMonth, endMonth) {
      const [y1, m1] = startMonth.split("-").map(Number);
      const [y2, m2] = endMonth.split("-").map(Number);
      const list = [];
      let y = y1;
      let m = m1;
      while (y < y2 || (y === y2 && m <= m2)) {
        list.push(`${y}-${String(m).padStart(2, "0")}`);
        if (m === 12) {
          y += 1;
          m = 1;
        } else {
          m += 1;
        }
      }
      return list;
    },
    // 新增流水统计：按启动时间月份统计团队客户当月批次服务费之和，区间内空月补 0
    fetchStartChart() {
      const startMonth = this.chartStartMonth;
      const endMonth = this.chartEndMonth;
      if (!startMonth || !endMonth) {
        this.chartData = [];
        this.renderStartChart();
        return;
      }
      const [y1, m1] = startMonth.split("-").map(Number);
      const [y2, m2] = endMonth.split("-").map(Number);
      const monthDiff = (y2 - y1) * 12 + (m2 - m1);
      if (monthDiff < 0) {
        this.$message.warning("结束月份不能早于开始月份");
        return;
      }
      if (monthDiff > 24) {
        this.$message.warning("时间间隔不能超过两年");
        return;
      }
      this.chartLoading = true;
      getSalesTeamStartStatisticsMonthly({ startDate: startMonth, endDate: endMonth })
        .then((res) => {
          if (res.msg === "success" && res.data) {
            const items = Array.isArray(res.data) ? res.data : res.data.items || [];
            const amountByMonth = {};
            items.forEach((d) => {
              const ym = (d.yearMonth || d.month || d.monthKey || "").toString();
              if (!ym) return;
              const c = Number(d.flowAmount);
              amountByMonth[ym] = (amountByMonth[ym] || 0) + (isNaN(c) ? 0 : c);
            });
            const fullMonths = this.getMonthRange(startMonth, endMonth);
            this.chartData = fullMonths.map((ym) => {
              const label = ym.replace("-", "年") + "月";
              return { yearMonth: ym, monthLabel: label, flowAmount: amountByMonth[ym] || 0 };
            });
            this.renderStartChart();
          } else {
            this.chartData = this.getMonthRange(startMonth, endMonth).map((ym) => ({
              yearMonth: ym,
              monthLabel: ym.replace("-", "年") + "月",
              flowAmount: 0,
            }));
            this.renderStartChart();
          }
        })
        .catch(() => {
          this.chartData = this.getMonthRange(startMonth, endMonth).map((ym) => ({
            yearMonth: ym,
            monthLabel: ym.replace("-", "年") + "月",
            flowAmount: 0,
          }));
          this.renderStartChart();
        })
        .finally(() => {
          this.chartLoading = false;
        });
    },
    renderStartChart() {
      if (!this.startChart) return;
      const aggregated = this.chartData;
      const months = aggregated.map((d) => d.yearMonth);
      const monthLabels = aggregated.map((d) => d.monthLabel);
      const values = aggregated.map((d) => (d.flowAmount != null ? Number(d.flowAmount) : 0));
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "line" },
          formatter: (params) => {
            if (!params || !params.length) return "";
            const idx = params[0].dataIndex;
            const ym = months[idx] || "";
            const val = aggregated[idx] ? aggregated[idx].flowAmount : 0;
            return `${ym}<br/>当月新增流水：${Number(val).toFixed(2)} 元`;
          },
        },
        grid: { left: 56, right: 32, bottom: 36, top: 36, containLabel: true },
        xAxis: {
          type: "category",
          data: monthLabels.length ? monthLabels : ["暂无数据"],
          axisLine: { lineStyle: { color: "#e4e7ed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        yAxis: {
          type: "value",
          name: "新增流水(元)",
          nameTextStyle: { color: "#606266", fontSize: 12 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#f0f0f0", type: "dashed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        series: [
          {
            name: "新增流水",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            data: values.length ? values : [0],
            itemStyle: { color: "#409EFF" },
            lineStyle: { width: 2 },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(64, 158, 255, 0.25)" },
                  { offset: 1, color: "rgba(64, 158, 255, 0.02)" },
                ],
              },
            },
          },
        ],
      };
      this.startChart.setOption(option, true);
      this.$nextTick(() => this.startChart && this.startChart.resize());
    },
    handleChartResize() {
      this.startChart && this.startChart.resize();
    },
  },
};
</script>

<style scoped>
.start-statistics-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.total-flow-card {
  margin-top: 8px;
  margin-bottom: 16px;
}
.chart-card {
  border-radius: 8px;
  overflow: hidden;
}
.chart-card >>> .el-card__header {
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
}
.chart-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chart-title-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.chart-card-header .header-icon {
  font-size: 18px;
  color: #409eff;
}
.chart-card >>> .el-card__body {
  padding: 20px;
}
.total-flow-header {
  flex-wrap: wrap;
  gap: 12px;
}
.total-flow-form {
  margin: 0;
}
.total-flow-form .el-form-item {
  margin-bottom: 0;
}
.range-sep {
  margin: 0 6px;
  color: #606266;
}
.chart-body {
  min-height: 320px;
  position: relative;
}
.chart-single-wrap {
  width: 100%;
  height: 320px;
}
.chart-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-radius: 6px;
  color: #c0c4cc;
}
.chart-empty i {
  font-size: 40px;
  margin-bottom: 8px;
}
.chart-empty p {
  margin: 0;
  font-size: 14px;
  color: #909399;
}

/* 搜索区、表格 - 与商户统计页风格一致 */
.search-section {
  margin-top: 0;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.current-month-tip {
  font-size: 13px;
  color: #909399;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/salesSupervisor/startStatistics.vue